import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { RootState } from './store';

export enum OrderDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}
export interface Pagination {
  offset?: number;
  limit?: number;
  orderBy?: string;
  orderDirection?: OrderDirection;
  countAll?: boolean;
}

export interface PaginationResponse {
  pagination: {
    hasMore: boolean;
    total?: number;
  };
}

export interface BulkActionResponse {
  success: boolean;
  count: number;
}

export const prepareHeaders = (
  headers: Headers,
  { getState }: { getState: () => unknown }
): Headers => {
  const root = getState() as RootState;
  const { user } = root;
  if (user.accessToken) {
    headers.set('Authorization', `Bearer ${user.accessToken}`);
  }
  return headers;
};

// Define a service using a base URL and expected endpoints
export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_BACKEND_BASE_URL}`,
    prepareHeaders,
  }),
  tagTypes: [
    'Users',
    'UserMatches',
    'UserSuggestions',
    'Events',
    'EventUsers',
    'EventMatches',
    'EventTemplates',
    'UserProfile',
    'MatchmakerPrompts',
    'VectorProfile',
    'VectorLabels',
    'PoolSnapshot',
    'AppVersionConfig',
    'VectorOps',
  ],
  endpoints: () => ({}),
});
